import { getDomExceptionErrorType, MediaDevicesErrorType } from '@/shared/composables/dom-exception-error-type'
import { useLocalization } from '@/shared/composables/localization'

import { PERMISSION_DENIED_ERROR_TEXT, PERMISSION_DISMISSED_ERROR_TEXT } from './constants'

export type MediaDeviceKind = 'microphone' | 'camera'

export const getMediaDevicesErrorMessage = (error: unknown, device: MediaDeviceKind): string => {
  const { t } = useLocalization()

  if (!(error instanceof DOMException)) {
    return error instanceof Error ? error.message : t('common.unknownError')
  }

  const errorType = getDomExceptionErrorType(error)

  if (errorType === MediaDevicesErrorType.SystemPermissionDenied) {
    return device === 'microphone'
      ? t('common.usingMicBlockByOs')
      : t('common.usingCamBlockByOs')
  }

  if (errorType === MediaDevicesErrorType.UserPermissionDenied) {
    return device === 'microphone'
      ? t('common.usingMicBlockByUser')
      : t('common.usingCamBlockByUser')
  }

  if (errorType === MediaDevicesErrorType.CouldNotStartVideoSource) {
    return t('common.selectDifferentCameraOrCloseApplicationUsingSelectedCamera')
  }

  if (error.message === PERMISSION_DENIED_ERROR_TEXT) {
    return device === 'microphone'
      ? t('common.needToGiveMicPermission')
      : t('common.permissionDenied')
  }

  if (error.message === PERMISSION_DISMISSED_ERROR_TEXT) {
    return t('common.micPermissionDismissed')
  }

  return error.message
}

export const getMicrophonePermissionErrorMessage = (e: unknown) => {
  return getMediaDevicesErrorMessage(e, 'microphone')
}
